/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable, NgZone} from '@angular/core';
import {AngularModalService} from './angular-modal.service';

import {ConfirmNavigationModalComponent} from './confirm-navigation-modal.component';

@Injectable({providedIn: 'root'})
export class ConfirmNavigationModalService {
  constructor(
    private readonly angularModalService: AngularModalService,
    private readonly ngZone: NgZone
  ) {
  }

  confirm(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      let settled = false;
      const settle = (leave: boolean) => {
        if (!settled) {
          settled = true;
          resolve(leave);
        }
      };

      // Transition hooks run outside Angular; open the modal inside NgZone so it renders.
      this.ngZone.run(() => {
        // animated:false — avoids the ~150ms open animation where hide() no-ops.
        // Buttons still force-hide via BsModalService because isShown flips in setTimeout(0).
        const modalRef = this.angularModalService.show(ConfirmNavigationModalComponent, {
          backdrop: 'static',
          ignoreBackdropClick: true,
          keyboard: false,
          animated: false,
          initialState: {
            onLeave: () => settle(true),
            onStay: () => settle(false)
          }
        });
        const component = modalRef.content as ConfirmNavigationModalComponent;
        if (component) {
          component.onLeave = () => settle(true);
          component.onStay = () => settle(false);
        }
        // Only treat unexpected dismiss as "stay". Leave/Stay settle first, then hide.
        modalRef.onHidden.subscribe(() => settle(false));
      });
    });
  }
}
